import { Link } from '@tanstack/react-router'
import { Wallet } from 'lucide-react'

export interface BillingMenuProps {
  walletBalanceCents: number
  billingTo: string
  /**
   * Whether the free trial is still running. Shown beside the balance rather
   * than instead of it: a $0 balance during the trial reads as "you cannot
   * send", which is the opposite of what is true.
   */
  onFreeTrial?: boolean
}

export function BillingMenu({ walletBalanceCents, billingTo, onFreeTrial }: BillingMenuProps) {
  return (
    <Link
      to={billingTo}
      className="flex h-9 items-center gap-2 rounded-lg px-2.5 text-muted-foreground outline-none transition-colors hover:bg-card hover:text-foreground"
    >
      <Wallet className="size-4" />
      <span className="text-sm font-semibold tabular-nums text-foreground">
        {`$${(walletBalanceCents / 100).toFixed(2)}`}
      </span>
      {onFreeTrial && (
        <span className="whitespace-nowrap rounded-full border border-emerald-500/40 bg-emerald-500/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-emerald-400">
          Free trial
        </span>
      )}
    </Link>
  )
}
